/**
 * Landing page.
 *
 * Explains what KinCode is in plain terms and offers the two entry points:
 * retrieve contacts (public) and create an account (owner). It must not describe
 * KinCode as an emergency service (§14).
 */

import { el, icon } from "../ui/dom.js";
import { pageHeader, section } from "../ui/patterns.js";

/** @type {import("../app/router.js").PageRenderer} */
export default function renderLanding() {
  const frag = document.createDocumentFragment();

  frag.append(
    pageHeader(
      "Your people, one code away",
      "KinCode lets you store the people who matter and recover their details with " +
        "a short phrase and a PIN — for the moments when a phone is lost, locked, or " +
        "flat.",
    ),
  );

  frag.append(
    el("div", { class: "kin-cta-row" }, [
      el("wa-button", { variant: "brand", href: "/retrieve", dataset: { link: "" } }, [
        icon("key"),
        "Retrieve contacts",
      ]),
      el("wa-button", { appearance: "outlined", href: "/register", dataset: { link: "" } }, [
        icon("user"),
        "Create an account",
      ]),
    ]),
  );

  frag.append(
    section("How it works", [
      el("ol", { class: "kin-steps" }, [
        el("li", {}, ["Create an account and add the contacts you want to be reachable."]),
        el("li", {}, ["KinCode gives you a recovery phrase and PIN to keep safe."]),
        el("li", {}, ["Anyone with the phrase and PIN can look up those contacts."]),
      ]),
    ]),
  );

  return frag;
}
